export default __webpack_public_path__ + "static/media/Patient_Care.31493d7d.png";